<template>
  <div class="row">
    <div class="col">
      <a class="mb-0" :href="streamConfigHref">
        {{ channel.name }}
      </a>
    </div>
    <div class="col">
      {{ stream.sep_state }}
    </div>
  </div>
</template>

<script>
import { Firebase } from "@/firebase.js";
export default {
  data() {
    return {
      stream: "",
    };
  },
  mounted() {
    var publish = Firebase.app().functions('europe-west2').httpsCallable('getStream')

    publish({ id: this.channel.id }).then((result) => {
      console.log(result)
      this.stream = result.data.job;
    });
  },
  props: ["channel"],
  computed: {
    streamConfigHref() {
      const id = this.channel.id;
      const p =
        (this.channel && this.channel.provider) ||
        (this.stream && this.stream.provider);
      const path = p === "aws" ? `aws-stream/${id}` : `stream/${id}`;
      return `/#/livestreams/${path}`;
    },
  },
  components: {},
  methods: {},
};
</script>

<style>
</style>
